import { createApp, onBeforeMount, h } from 'vue';
import { useStore } from '@components/common/store';
import { determinePageType } from '@utils/utils';
import { mountReplace } from '@/js/utils/mountUtils';
import HotelPageMainContent from './HotelPageMainContent.vue';

const mountPoint = document.querySelector('#hotel-page-menu');

const initHotelPage = (): void => {
	const dataset = document.getElementById('typo-data')?.dataset;
	if (!dataset || !dataset.hoteldata) return;

	const store = useStore();

	const hotelData = JSON.parse(dataset.hoteldata);

	const hotelInfoDataset = document.getElementById('hotel-page-menu')?.dataset;
	if (!hotelInfoDataset) return;

	// Add phone number from headerSearch's dataset to all dataset in case the headerSearch renders after the content search
	const headerSearch: HTMLElement | null = document.getElementById('search-form__main');
	if (headerSearch && !dataset.phone) {
		dataset.phone = headerSearch?.dataset.phone;
		dataset.phoneLink = headerSearch?.dataset.phoneLink;
	}

	const HotelPageMainContentApp = createApp({
		name: 'HotelPageMainContent',
		setup() {
			onBeforeMount(() => {
				if (!store.state.config.storeInitialized) {
					store.dispatch('initStore', dataset);
				}
			});
		},
		render: () => h(HotelPageMainContent, {
			hotelInfo: hotelData,
			mapData: {
				key: hotelInfoDataset.mapsKey as string,
				staticMaps: {
					staticgmap_544: hotelInfoDataset['staticMaps-544'] as string,
					staticgmap_992: hotelInfoDataset['staticMaps-992'],
					staticgmap_1200: hotelInfoDataset['staticMaps-1200'],
					staticgmap_1440: hotelInfoDataset['staticMaps-1440'],
				}
			},
		}),
	});
	// This way the Vue devtools will have the store tab available
	HotelPageMainContentApp.use(store);

	mountReplace(HotelPageMainContentApp, mountPoint!);
};

const pageType = determinePageType();

if (pageType === 'hotelPage' && mountPoint) {
	initHotelPage();
}
